import { getErrorPayload } from '@application/common/helpers/api-helper';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { visserApi } from '@infrastructure/visserApi';
export const getRecordNumberById = createAsyncThunk('common/getRecordNumberById', async (request, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await visserApi.post('common/getRecordNumberById', request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
